import { getAllPlanDetails, paymentInitiateApiCall, ecomPaymentInitiateApi, ecomEsimPaymentInitiateApi } from "../api/api";
import { SequenceManagerAction } from '../actions/SequenceManagerAction';

const CheckoutAction = {
    HANDLE_CHECKOUT: "HANDLE_CHECKOUT",
    CHECKOUT_PLAN_DETAILS_SUCCESS: "CHECKOUT_PLAN_DETAILS_SUCCESS",
    INITIATE_PAYMENT_SUCCESS: "INITIATE_PAYMENT_SUCCESS"
} as const

const getPlanDetails = (externalIds: any) => {
    return function (dispatch: any) {
        getAllPlanDetails(externalIds).then((response) => {
            dispatch({ type: CheckoutAction.CHECKOUT_PLAN_DETAILS_SUCCESS, payload: response.data });
        })
            .catch((error) => {
                //Display error
                dispatch({ type: SequenceManagerAction.GENERIC_ERROR, payload: error });
            })
    }
}

const initiatePayment = () => {
    return function (dispatch: any) {
        paymentInitiateApiCall().then((response) => {
            dispatch({ type: CheckoutAction.INITIATE_PAYMENT_SUCCESS, payload: response });
        })
            .catch((error) => {
                //Display error
                dispatch({ type: SequenceManagerAction.GENERIC_ERROR, payload: error });
            })
    }
}

const ecomInitiatePayment = () => {
    return function (dispatch: any) {
        ecomPaymentInitiateApi().then((response) => {
            dispatch({ type: CheckoutAction.INITIATE_PAYMENT_SUCCESS, payload: response });
        })
            .catch((error) => {
                //Display error
                dispatch({ type: SequenceManagerAction.GENERIC_ERROR, payload: error });
            })
    }
}

const ecomEsimInitiatePayment = () => {
    return function (dispatch: any) {
        ecomEsimPaymentInitiateApi().then((response) => {
            dispatch({ type: CheckoutAction.INITIATE_PAYMENT_SUCCESS, payload: response });
        })
            .catch((error) => {
                //Display error
                dispatch({ type: SequenceManagerAction.GENERIC_ERROR, payload: error });
            })
    }
}

const handleCheckout = (paymentMethod: any) => {
    return function (dispatch: any) {
        dispatch({ type: CheckoutAction.HANDLE_CHECKOUT, payload: { paymentMethod: paymentMethod } });
        dispatch({ type: SequenceManagerAction.SECTION_COMPLETE, payload: ['paymentMethodAndTermsConditions'] });
    };
};

export { CheckoutAction, getPlanDetails, handleCheckout, initiatePayment, ecomInitiatePayment, ecomEsimInitiatePayment };